import classnames from 'classnames'

import Box from '~/core/Box'
import Tooltip from '~/core/Tooltip'
import Text from '~/core/Text'
import Image from '~/core/Image'
import {
    docPhotosOnly,
    BLACK_ALPHA_BOTTOM,
    ATTACHMENT_FILE_TYPE,
    HEADER_STYLES,
} from '~/apps/consumer/components/PartViewerModal/logic'
import { DimensionalComponentsType } from '~/apps/consumer/components/PartViewerModal/types'
import styles from '~/apps/consumer/components/PartViewerModal/styles.css'

import PDFThumbnail from './PDFThumbnail'
import InspectionDrawingThumbnail from './InspectionDrawingThumbnail'

export function DimensionalCard(props: DimensionalComponentsType) {
    const {
        fictiv5s,
        manufacturingDrawing,
        selectedInspectionDocument,
        setInspectionDocumentIdx,
    } = props

    const fictiv5Images = fictiv5s?.filter(docPhotosOnly)
    let selectedInspectionDocumentUrl: string | null = null

    if (selectedInspectionDocument < fictiv5Images.length) {
        selectedInspectionDocumentUrl =
            fictiv5Images[selectedInspectionDocument].downloadUrl
    }

    const partPhotosOnly = fictiv5s.filter(fictiv5 =>
        fictiv5?.mimeType?.includes(ATTACHMENT_FILE_TYPE.IMAGE),
    )

    return (
        <Box borderBottom={BLACK_ALPHA_BOTTOM} direction="col" padding="16px 0">
            <Text
                style={{
                    ...HEADER_STYLES,
                    marginBottom:
                        fictiv5s.length === 0 && !manufacturingDrawing
                            ? '0px'
                            : '8px',
                }}
            >
                Inspection documents
            </Text>
            <Box
                direction="row"
                className={styles.wrapperForPhotoAndDocumentTiles}
            >
                {fictiv5s?.map(fictiv5 => {
                    const isSelected =
                        fictiv5?.downloadUrl === selectedInspectionDocumentUrl

                    if (
                        fictiv5?.mimeType?.includes(ATTACHMENT_FILE_TYPE.IMAGE)
                    ) {
                        return (
                            <Tooltip
                                title={fictiv5.fileName}
                                key={fictiv5.createdAt}
                            >
                                <Box
                                    onClick={() => {
                                        setInspectionDocumentIdx(
                                            partPhotosOnly.findIndex(
                                                photo =>
                                                    photo.downloadUrl ===
                                                    fictiv5.downloadUrl,
                                            ),
                                        )
                                    }}
                                    data-test-target="fictiv5-photo-thumbnail"
                                >
                                    <Image
                                        className={classnames(
                                            styles.inspectionThumbnail,
                                            isSelected &&
                                                styles.inspectionThumbnailSelected,
                                        )}
                                        src={fictiv5.downloadUrl}
                                    />
                                </Box>
                            </Tooltip>
                        )
                    }
                    return (
                        <PDFThumbnail key={fictiv5.createdAt} file={fictiv5} />
                    )
                })}
                {!!manufacturingDrawing && (
                    <InspectionDrawingThumbnail
                        key={manufacturingDrawing.createdAt}
                        file={manufacturingDrawing}
                    />
                )}
            </Box>
        </Box>
    )
}
